module.exports = __webpack_public_path__ + "img/f3-en.747b2841.jpeg";